
import Base64 from './base64.js'
var CryptoJS = require('./aes.js') // 引用AES源码js
var randomIv = randomWord(false, 16)
// var randomIv = '12345678qwertyui';
var key = CryptoJS.enc.Utf8.parse('qgmg_!qgmg@admin')// 十六位十六进制数作为秘钥 （qmotor-aes2_secret）
var iv = CryptoJS.enc.Utf8.parse(randomIv)// 十六位十六进制数作为秘钥偏移量
/*
** randomWord 产生任意长度随机字母数字组合
** randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
**使用方法---
**生成3-32位随机串：randomWord(true, 3, 32)
**生成43位随机串：randomWord(false, 43)
*/
function randomWord (randomFlag, min, max) {
  var str = '',
    range = min,
    arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min
  }
  for (var i = 0; i < range; i++) {
    var pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}

function Decrypt (word) {
  var encryptedHexStr = CryptoJS.enc.Hex.parse(word)
  var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  var decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}

function Encrypt (word) {
  var srcs = word
  var encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.toString()
}

export default{

  // 解密方法--可能不对，暂不需要
  Decrypt (word) {
    var encryptedHexStr = CryptoJS.enc.Hex.parse(word)
    var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
    var decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    return decryptedStr.toString()
  },

  // 加密方法
  Encrypt (word) {
    var srcs = word
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
    return encrypted.toString()
  },

  // 1. aes128加密模式  AES - CBC - 128)
  // 2. 要传给后台的数据转为json
  // 3. 偏移量iv前台动态生成(16位)
  // 4. 偏移量拼接加密后的字符串
  // 5. 拼接完成后进行base64加密(默认utf8编码)
  // 例如:
  // 要传给后台的数据:
  // $data = array(
  //   "mobile" => "13810949258"
  // );
  // 转为json后:
  // { "mobile":"13810949258" }
  // iv: 12345678qwertyui
  // 加密后的字符串: J9X4XNgo3iIeTcUr10AyKocrlLrmSmr4x8Kqx / sPzpc=
  // 偏移量拼接加密后字符串: 12345678qwertyuiJ9X4XNgo3iIeTcUr10AyKocrlLrmSmr4x8Kqx/ sPzpc=
  // 最终结果进行base64加密: MTIzNDU2Nzhxd2VydHl1aUo5WDRYTmdvM2lJZVRjVXIxMEF5S29jcmxMcm1TbXI0eDhLcXgvc1B6cGM9
  // 传输给服务器的数据
  // $data = array(
  //   'data'=>'MTIzNDU2Nzhxd2VydHl1aUo5WDRYTmdvM2lJZVRjVXIxMEF5S29jcmxMcm1TbXI0eDhLcXgvc1B6cGM9'
  // );

  // 经过aes加密后的自定义加密方法,拼上随机iv后base64加密
  selfEncrypt (obj) {
    var word = JSON.stringify(obj)
    var aesStr = Encrypt(word)// aes加密后的字符串
    var str = randomIv + aesStr
    // console.log(str)
    var base = new Base64()
    var result = base.encode(str)
    var postData = { data: result }
    return postData
  }

}
// 暴露接口
// module.exports.Decrypt = Decrypt;
// module.exports.Encrypt = Encrypt;
// module.exports.selfEncrypt = selfEncrypt;



// WEBPACK FOOTER //
// ./static/public.js